import React from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { ColorSelector } from '../ColorSelector';
export const CarportColorStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Kleur carport" description="Kies de kleur die het beste bij uw woning past." isActive={true} data-id="element-827">
      <ColorSelector selectedColor={formData.carportColor} onSelect={color => handleOptionSelect('carportColor', color)} data-id="element-828" />
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.carportColor} data-id="element-829" />
    </FormStep>;
};